import { Box, Button, Modal, Typography } from "@mui/material";
import OnboardingCompanyModal from "./OnboardingModal";
import { useState } from "react";

const style = {
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	width: 650,
	bgcolor: "background.paper",
	borderRadius: "1rem",
	p: 4,
};

const ConfirmCompanyModal = ({
	showModal,
	closeModal,
	selectedCompany,
	setSelectedCompany,
	setSearch,
	setItems,
	closeAddCompanyModal,
	fetchCompanies,
}) => {
	const {
		company_name,
		company_number,
		date_of_cessation,
		date_of_creation,
		registered_office_address,
	} = selectedCompany;
	const address = `${registered_office_address.address_line_1} ${registered_office_address.locality} ${registered_office_address.postal_code}`;

	const [showOnboardingModal, setShowOnboardingModal] = useState(false);

	return (
		<Modal
			open={showModal}
			onClose={closeModal}
			aria-labelledby='modal-modal-title'
			aria-describedby='modal-modal-description'>
			<Box sx={style}>
				{showOnboardingModal && (
					<OnboardingCompanyModal
						selectedCompany={selectedCompany}
						showModal={showOnboardingModal}
						closeModal={() => setShowOnboardingModal(false)}
						closeAddCompanyModal={closeAddCompanyModal}
						fetchCompanies={fetchCompanies}
					/>
				)}
				<Typography variant='h5' fontWeight='bold'>
					Confirm Company
				</Typography>
				<Box
					sx={{
						border: "1px solid #E0E0E0",
						padding: "2rem",
						marginTop: "2rem",
						borderRadius: "0.5rem",
					}}>
					<Typography
						variant='h5'
						fontWeight='bold'
						marginBottom='1rem'>
						{company_name}
					</Typography>
					<Typography
						variant='h6'
						fontWeight='bold'
						marginBottom='0.75rem'>
						CRN: {company_number}
					</Typography>
					<Box
						sx={{
							display: "flex",
							alignItems: "center",
							gap: "1rem",
							marginBottom: "0.75rem",
						}}>
						<Typography variant='subtitle1' fontWeight='bold'>
							Address:
						</Typography>
						<Typography variant='subtitle2'>{address}</Typography>
					</Box>
					<Typography variant='body1' marginBottom='0.5rem'>
						Next Accounts made up to:{" "}
						{new Date(date_of_cessation).toDateString()}
					</Typography>
					<Typography variant='body1'>
						Next Statements made up to:{" "}
						{new Date(date_of_creation).toDateString()}
					</Typography>
				</Box>
				<Box
					sx={{
						display: "flex",
						justifyContent: "flex-start",
						marginTop: "1rem",
						gap: "1rem",
					}}>
					<Button
						variant='contained'
						sx={{ backgroundColor: "#800080", color: "#fff" }}
						onClick={() => setShowOnboardingModal(true)}>
						Confirm Company
					</Button>
					<Button
						variant='outlined'
						sx={{
							border: "1px solid #ccc",
							color: "#800080",
						}}
						onClick={() => {
							setSearch("");
							setSelectedCompany(null);
							setItems([]);
							closeModal();
						}}>
						Search Again
					</Button>
				</Box>
			</Box>
		</Modal>
	);
};

export default ConfirmCompanyModal;
